module.exports = __webpack_public_path__ + "static/media/9DESA22.8957fddc.jpg";